import { ErroTaxasFidc } from '../../../../shared/model/fidcTaxas';
import FidcParametros from './fidcParametros';
import { useVerificaPermissao } from '../../../../shared/useVerificaPermissao';
import 'bootstrap/dist/css/bootstrap.css';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useLocation, useParams } from 'react-router-dom';
import Spinner from '../../../../shared/spinner';
import InputMask from 'react-input-mask';
import { Fidc } from '../../../../shared/model/fidc';
import { cnpj as cnpjValidacao } from 'cpf-cnpj-validator';
import FidcService from '../../../../services/fidcService';
import CustomAlert from '../../../../shared/customAlert';

function FidcInlusaoAlteracao() {
  useVerificaPermissao();
  const [parametros, setParametros] = useState<Fidc>(new Fidc());
  const [alert, setAlert] = useState<{ message: string, type: 'success' | 'warning' | 'error' } | null>(null);
  const location = useLocation();
  const { id } = location.state || {};
  const { tipo } = useParams();
  
  const [nome, setNome] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [banco, setBanco] = useState('');
  const [agencia, setAgencia] = useState('');
  const [conta, setConta] = useState('');

  // Estados corrigidos. Usamos boolean para o checkbox.
  const [habilitaSiglaFuncionario, setHabilitaSiglaFuncionario] = useState(false);
  const [sigla, setSigla] = useState('');
  // Usando '1'/'0' como strings para o select, mas mapeando para number no payload
  const [aceitaFuncionarioNaoEfetivo, setAceitaFuncionarioNaoEfetivo] = useState('0'); 
  const [contratoAnterior, setContratoAnterior] = useState(''); 

  const [loading, setLoading] = useState(false);

  const fidcService: FidcService = new FidcService();

  const listarFidcPorId = async () => {
    setLoading(true);
    try {
      const response = await fidcService.listarFidcPorId(id);
      const json = response.data;
      setParametros({ ...new Fidc(), ...json, elegibilidade: json.elegibilidade || new Fidc().elegibilidade });
      
      setNome(json.nome);
      setCnpj(json.cnpj);
      setBanco(json.banco);
      setAgencia(json.agencia);
      setConta(json.conta);
      
      // Carregamento e mapeamento dos novos campos
      setSigla(json.tipoContrato || ''); // Mapeamento: 'tipoContrato' -> 'sigla'
      
      // Mapeamento: 'afne' (boolean/number) -> '1'/'0' para o <select>
      const afneValue = json.afne === 1 || json.afne === true ? '1' : '0';
      setAceitaFuncionarioNaoEfetivo(afneValue);
      
      setContratoAnterior(json.ca ? String(json.ca) : ''); // Mapeamento: 'ca' -> 'contratoAnterior'

      // Lógica de habilitação: Se algum dos 3 campos retornar dados válidos, o checkbox deve vir marcado.
      const shouldBeChecked = !!json.tipoContrato || json.afne === 1 || json.afne === true || json.ca > 0;
      setHabilitaSiglaFuncionario(shouldBeChecked); 

      setLoading(false);
    } catch (err) {
      setLoading(false);
      console.error(err);
    }
  };

  const handleSubmit = async (event: any) => {
    event.preventDefault();

    if (!cnpjValidacao.isValid(cnpj)) return setAlert({ message: 'CNPJ Inválido', type: 'warning' });

    // Validação condicional dos novos campos
    if (habilitaSiglaFuncionario) {
      if (!sigla.trim()) return setAlert({ message: 'A Sigla é obrigatória', type: 'warning' });
      const contrato = parseInt(contratoAnterior, 10);
      if (!contratoAnterior.trim() || isNaN(contrato) || contrato <= 0) return setAlert({ message: 'O Contrato Anterior deve ser um valor numérico positivo', type: 'warning' });
    }
    
    let fidc: Fidc = { ...parametros };
    fidc.id = id ? parseInt(id) : null;
    fidc.nome = nome;
    fidc.cnpj = cnpj;
    fidc.banco = banco;
    fidc.agencia = agencia;
    fidc.conta = conta;
    
    // Inclusão dos novos campos no objeto a ser salvo com o mapeamento e limpeza corretos
    
    // Mapeamento: sigla (input) -> tipoContrato (API)
    fidc.tipoContrato = habilitaSiglaFuncionario && sigla.trim() ? sigla.trim() : null; 
    
    // Mapeamento: aceitaFuncionarioNaoEfetivo (input '1'/'0') -> afne (API 1/0)
    // Se o checkbox estiver desligado, envia 0 (Não aceita).
    fidc.afne = habilitaSiglaFuncionario ? parseInt(aceitaFuncionarioNaoEfetivo, 10) : 0; 
    
    // Mapeamento: contratoAnterior (input) -> ca (API - number)
    fidc.ca = habilitaSiglaFuncionario && contratoAnterior.trim() ? parseInt(contratoAnterior, 10) : null;

    try {
      setLoading(true);
      await fidcService.incluirAlterarFidc(fidc);

      setLoading(false);
      if (tipo === 'inclusao') {
        setAlert({ message: 'FIDC salvo com sucesso!', type: 'success' });
      }else{
        setAlert({ message: 'FIDC alterado com sucesso!', type: 'success' });
      }
    } catch (err: any) {
      setLoading(false);
      setAlert({ message: err instanceof ErroTaxasFidc ? err.message : typeof err.response?.data === 'string' ? err.response.data : 'Ocorreu um erro ao alterar o FIDC!', type: 'error' });
      console.error(err);
    }
  };

  useEffect(() => {
    if (tipo === 'alteracao') {
      listarFidcPorId();
    }
  }, []);
  
  // Função para limpar os campos quando o checkbox for desmarcado
  const handleHabilitaChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setHabilitaSiglaFuncionario(isChecked);
    if (!isChecked) {
      // Limpa os campos e redefine para os valores padrão de "desligado"
      setSigla('');
      setAceitaFuncionarioNaoEfetivo('0');
      setContratoAnterior('');
    }
  };

  return (
    <div className="container">
      {alert && (<CustomAlert message={alert.message} type={alert.type} onClose={()=> { setAlert(null); if (alert.type === 'success') {window.history.back();} }} />)}
      {loading ? <Spinner loading={loading} /> : (
        <form onSubmit={handleSubmit}>
          <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              {tipo === 'inclusao' ? <h5>BackOffice &gt; Tabelas &gt; FIDC &gt; Inclusão</h5> : (
                <h5>BackOffice &gt; Tabelas &gt; FIDC &gt; Alteração</h5>
              )}
              <Button id="App-button-cor-principal" onClick={() => window.history.back()}>
                Voltar
              </Button>
            </div>
            <hr className="my-4" />
          </div>

          <div className="row">
            {tipo === 'alteracao' ? (
              <div className="col-md-1">
                <label>Código</label>
                <input readOnly type="text" className="form-control" value={id} style={{ backgroundColor: 'LightGrey' }} />
              </div>
            ) : null}
            <div className="col-xl">
              <label>Nome <span style={{ color: 'red' }}>*</span></label>
              <input required type="text" className="form-control" value={nome} onChange={(e) => setNome(e.target.value)} />
            </div>
            <div className="col-xl">
              <label>CNPJ <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="99.999.999/9999-99" type="text" className="form-control" value={cnpj} onChange={(e) => setCnpj(e.target.value)} />
            </div>
          </div>

          <div className="row">
            <div className="col-xl">
              <label>Banco <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="999" type="text" className="form-control" 
                value={banco} onChange={(e) => setBanco((e.target.value).replace(/_/g, ""))}
              />
            </div>
            <div className="col-xl">
              <label>Agência <span style={{ color: 'red' }}>*</span></label> 
              <InputMask required mask="9999" type="text" className="form-control"
                value={agencia} onChange={(e) => setAgencia((e.target.value).replace(/_/g, ""))}
              />
            </div>
            <div className="col-xl">
              <label>Conta <span style={{ color: 'red' }}>*</span></label>
              <InputMask required mask="99999999-9" type="text" className="form-control" maskChar={null}
                value={conta} onChange={(e) => setConta((e.target.value).replace(/_/g, ""))}
              />
            </div>
          </div>

          <hr className="my-4" />

          <FidcParametros value={parametros} onChange={setParametros} />
          {/* CHECKBOX para habilitar os campos */}
          <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="habilitaCamposAdicionais"
              // O 'checked' agora usa o estado booleano
              checked={habilitaSiglaFuncionario}
              onChange={handleHabilitaChange}
            />
            <label className="form-check-label" htmlFor="habilitaCamposAdicionais">
              Habilitar Campos Adicionais (Sigla e Funcionário Não Efetivo)
            </label>
          </div>

          {/* CAMPOS ADICIONAIS - Desabilitados por padrão */}
          <div className="row">
            <div className="col-xl">
              <label>Sigla (Ex: EUD FCT)</label>
              <input 
                type="text" 
                className="form-control" 
                value={sigla} 
                onChange={(e) => setSigla(e.target.value.toUpperCase())} 
                disabled={!habilitaSiglaFuncionario} 
                required={habilitaSiglaFuncionario}
              />
              {!habilitaSiglaFuncionario && <small className="form-text text-muted">Habilite o checkbox acima para preencher.</small>}
            </div>

            <div className="col-xl">
              <label>Aceita funcionário não efetivo <span style={{ color: 'red' }}>*</span></label>
              <select
                className="form-control"
                value={aceitaFuncionarioNaoEfetivo}
                onChange={(e) => setAceitaFuncionarioNaoEfetivo(e.target.value)}
                disabled={!habilitaSiglaFuncionario}
                required={habilitaSiglaFuncionario}
              >
                <option value="0">Não</option>
                <option value="1">Sim</option>
              </select>
              {!habilitaSiglaFuncionario && <small className="form-text text-muted">Habilite o checkbox acima para preencher.</small>}
            </div>
          </div>
          
          <div className="row mt-3">
            <div className="col-xl-4"> {/* Use uma coluna menor para este campo */}
              <label>Contrato anterior (Ex: 96 meses) <span style={{ color: 'red' }}>*</span></label>
              <div className="input-group">
                <input 
                  type="number" 
                  className="form-control" 
                  value={contratoAnterior} 
                  onChange={(e) => setContratoAnterior(e.target.value)} 
                  disabled={!habilitaSiglaFuncionario} 
                  required={habilitaSiglaFuncionario}
                  min="0"
                />
                <div className="input-group-append">
                  <span className="input-group-text">meses</span>
                </div>
              </div>
              {!habilitaSiglaFuncionario && <small className="form-text text-muted">Habilite o checkbox acima para preencher.</small>}
            </div>
            <div className="col-xl-8"></div> {/* Coluna vazia para alinhamento */}
          </div>


          <div>
            <hr className="my-4" />
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <button className="w-40 btn btn-primary btn-lg btn btn-success" type="submit">{tipo !== 'inclusao' ? 'Alterar FIDC': 'Salvar FIDC'}</button>
            </div>
            </div>
          </div>
        </form>
      )}
    </div>
  );
}

export default FidcInlusaoAlteracao;